(function() { window.GUID_859b9710_55ac_4a10_833d_3560cef5ee5c = { getGuid: function() { return "859b9710-55ac-4a10-833d-3560cef5ee5c"; } }; })();
var PersonnalSchedule;
(function (PersonnalSchedule) {
    $(function () {
        let gridViewPersonnalScheduleUI = $('#GridViewPersonnalSchedule');
        let gridViewPersonnalSchedule = gridViewPersonnalScheduleUI.data('context');
        CS.body.on('Refreshed', '#GridViewPersonnalSchedule', function (e, gridView) {
            gridViewPersonnalSchedule = gridView;
        });
        var btnPrintSchedule = $('#BtnPrintSchedule');
        btnPrintSchedule.off('click');
        document.SelectedEntityBaseId.SelectionChange = function () {
            if (this.val() != "0" && this.val() != "") {
                btnPrintSchedule.removeClass('IsDisabled');
            }
            else {
                btnPrintSchedule.addClass('IsDisabled');
            }
        };
        btnPrintSchedule.on('click', 'a', function (e) {
            var reportParam = "?ReportName=LeagueEntitySchedule" +
                "&ShowReportViewer=false" +
                "&EntityBaseId=" + document.SelectedEntityBaseId.val() +
                "&SelectedStatGroupId=null";
            this.target = "_blank";
            this.href = CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam;
            document.SelectedEntityBaseId.val();
        });
    });
})(PersonnalSchedule || (PersonnalSchedule = {}));

//# sourceMappingURL=PersonnalSchedule.js.map
